import { render, staticRenderFns } from "./AppAiAssessmentReport.vue?vue&type=template&id=2088e7a2&scoped=true"
import script from "./AppAiAssessmentReport.vue?vue&type=script&lang=ts"
export * from "./AppAiAssessmentReport.vue?vue&type=script&lang=ts"
import style0 from "./AppAiAssessmentReport.vue?vue&type=style&index=0&id=2088e7a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2088e7a2",
  null
  
)

export default component.exports